import { useGetBackProcedimentiIdCampiSemanticiPratica } from '@framework/api-client/api/backoffice/procedimenti/procedimenti.ts';
import { type ProcedimentoConTask } from '@framework/api-client/api/backoffice/schemas/procedimentoConTask.ts';

/**
 * Hook che gestisce il recupero dei campi semantici di pratica di
 * un procedimento.
 */
export function useProcedureDossierSemanticFields(
  procedure: ProcedimentoConTask | null | undefined,
) {
  const enabled = Boolean(
    procedure &&
      procedure.contieneCampiSemanticiPratica === true &&
      procedure.id != null,
  );

  const { data, isLoading, error, isFetching } =
    useGetBackProcedimentiIdCampiSemanticiPratica(
      procedure?.id ?? '<unknown>',
      {
        query: {
          enabled,
        },
      },
    );

  return { data: data?.data, isLoading, error, isFetching };
}
